package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.DateRangeW500Rounded: ImageVector
    get() {
        if (_dateRangeW500Rounded != null) {
            return _dateRangeW500Rounded!!
        }
        _dateRangeW500Rounded = Builder(name = "DateRangeW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(285.64f, 546.96f)
                quadToRelative(-12.34f, -12.32f, -12.34f, -30.53f)
                reflectiveQuadToRelative(12.32f, -30.67f)
                quadToRelative(12.32f, -12.46f, 30.54f, -12.46f)
                quadToRelative(18.21f, 0.0f, 30.55f, 12.46f)
                quadToRelative(12.33f, 12.46f, 12.33f, 30.67f)
                reflectiveQuadToRelative(-12.32f, 30.53f)
                quadToRelative(-12.32f, 12.32f, -30.53f, 12.32f)
                reflectiveQuadToRelative(-30.55f, -12.32f)
                close()
                moveTo(449.47f, 546.96f)
                quadToRelative(-12.34f, -12.32f, -12.34f, -30.53f)
                reflectiveQuadToRelative(12.32f, -30.67f)
                quadToRelative(12.32f, -12.46f, 30.53f, -12.46f)
                quadToRelative(18.22f, 0.0f, 30.55f, 12.46f)
                quadToRelative(12.34f, 12.46f, 12.34f, 30.67f)
                reflectiveQuadToRelative(-12.32f, 30.53f)
                quadToRelative(-12.32f, 12.32f, -30.53f, 12.32f)
                quadToRelative(-18.22f, 0.0f, -30.55f, -12.32f)
                close()
                moveTo(613.29f, 546.96f)
                quadToRelative(-12.33f, -12.32f, -12.33f, -30.53f)
                reflectiveQuadToRelative(12.32f, -30.67f)
                quadToRelative(12.32f, -12.46f, 30.53f, -12.46f)
                reflectiveQuadToRelative(30.55f, 12.46f)
                quadToRelative(12.34f, 12.46f, 12.34f, 30.67f)
                reflectiveQuadToRelative(-12.32f, 30.53f)
                quadToRelative(-12.32f, 12.32f, -30.54f, 12.32f)
                quadToRelative(-18.21f, 0.0f, -30.55f, -12.32f)
                close()
                moveTo(202.87f, 888.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-554.26f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                lineTo(240.0f, 151.87f)
                verticalLineToRelative(-37.37f)
                quadToRelative(0.0f, -17.96f, 12.46f, -30.29f)
                quadToRelative(12.45f, -12.34f, 30.41f, -12.34f)
                reflectiveQuadToRelative(30.29f, 12.34f)
                quadToRelative(12.34f, 12.33f, 12.34f, 30.29f)
                verticalLineToRelative(37.37f)
                horizontalLineToRelative(309.0f)
                verticalLineToRelative(-37.37f)
                quadToRelative(0.0f, -17.96f, 12.46f, -30.29f)
                quadToRelative(12.45f, -12.34f, 30.41f, -12.34f)
                reflectiveQuadToRelative(30.29f, 12.34f)
                quadTo(720.0f, 96.54f, 720.0f, 114.5f)
                verticalLineToRelative(37.37f)
                horizontalLineToRelative(37.13f)
                quadToRelative(37.78f, 0.0f, 64.39f, 26.61f)
                reflectiveQuadToRelative(26.61f, 64.39f)
                verticalLineToRelative(554.26f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(202.87f, 888.13f)
                close()
                moveTo(202.87f, 797.13f)
                horizontalLineToRelative(554.26f)
                lineTo(757.13f, 400.0f)
                lineTo(202.87f, 400.0f)
                verticalLineToRelative(397.13f)
                close()
                moveTo(202.87f, 320.0f)
                horizontalLineToRelative(554.26f)
                verticalLineToRelative(-77.13f)
                lineTo(202.87f, 242.87f)
                lineTo(202.87f, 320.0f)
                close()
                moveTo(202.87f, 320.0f)
                verticalLineToRelative(-77.13f)
                lineTo(202.87f, 320.0f)
                close()
            }
        }
        .build()
        return _dateRangeW500Rounded!!
    }

private var _dateRangeW500Rounded: ImageVector? = null
